import { render, staticRenderFns } from "./salesCommission.vue?vue&type=template&id=c7faf3a6&scoped=true"
import script from "./salesCommission.vue?vue&type=script&lang=js"
export * from "./salesCommission.vue?vue&type=script&lang=js"
import style0 from "./salesCommission.vue?vue&type=style&index=0&id=c7faf3a6&prod&lang=less&scoped=true"
import style1 from "./salesCommission.vue?vue&type=style&index=1&id=c7faf3a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7faf3a6",
  null
  
)

export default component.exports